import styled from '@emotion/styled';
import { breakpoints } from '~/theme/breakpoints';

export const PDPAside = styled.aside(() => ({
    width: '100%',
    flexShrink: 0,
    [breakpoints.sm]: {
        width: 390,
    },
    [breakpoints.lg]: {
        width: 414,
    },
}));
